import { Component } from '@angular/core';

@Component({
    selector: 'layout-ro',
    templateUrl: 'layout-ro.component.html',
})
export class LayoutRoComponent {
}
